export default class AuthenticateInfo {
  static validatePasswordFormat (word) {
    if (word.trim().match(/^([A-Za-z0-9]|@|\.|_|\/|-|\+|\(|\)){8,120}$/g)) {
      return true
    } else {
      return false
    }
  }
}
